<template lang="pug">
Page(title="Review", :items="items")
</template>

<script>
export default {
  data() {
    return {
      items: [
        { title: "DashBoard", url: "/reviews/dashboard" },
        { title: "Recent", url: "/reviews/recent" },
        { title: "Search", url: "/reviews/search" },
      ],
    };
  },
};
</script>
